import React, { PureComponent } from 'react';
import { View, StyleSheet, TouchableOpacity, Platform, Image, Text } from 'react-native';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';
import PhoneInput from "react-native-phone-input";
import PhoneNumber from 'react-native-phone-input/lib/phoneNumber';
import Theme from '../../theme';
import { Dropdown } from '../../ui';
import { defaultScale } from '../../utils/scaling';
import { getDialCodeFromNumberOrFallbackToAus } from '../../utils/string-manipulation'

class CountryCodePicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      defaultCountry: {},
    }
  }

  componentDidMount = async () => {
    const { initialize } = this.props;
    if (this.phone) {
      const pickerData = this.getCountryDropDown();
      this.setState({
        pickerData,
      });

      if (pickerData) {
        let pickerDataWithImage = pickerData.map(country => {
          country.thumbnail = this.getCountryPickerElement(
            country.image,
            country.dialCode
          );
          return country;
        });
        const defaultCountry = this.defaultCountry();
        this.setState({
          pickerDataWithImage, defaultCountry,
        });
        this.props.onDialCodeSet(defaultCountry);
        initialize({ countryCode: defaultCountry })
      }
    }
  };

  defaultCountry = () => {
    if (!this.phone) {
      return;
    }
    const pickerData = this.getCountryDropDown();
    const mobileNumber = this.props.userProfile && this.props.userProfile.mobileNumber;

    const { defaultCountry: defaultCountryProp } = this.props;
    const defaultCountryPropCountryData = pickerData.find(({ iso2 }) => iso2 === defaultCountryProp);
    if (defaultCountryProp && defaultCountryPropCountryData) {
      this.setState({ countryCode: defaultCountryPropCountryData.dialCode });
      return defaultCountryPropCountryData.dialCode;
    }

    if (mobileNumber && mobileNumber !== ' ') {
      const dialCode = getDialCodeFromNumberOrFallbackToAus(mobileNumber, pickerData);
      this.setState({countryCode: dialCode});
      const indexOfDialCode = pickerData.map(e => e.dialCode).indexOf(dialCode);
      if (Platform.OS === 'web') {
        return pickerData[indexOfDialCode].dialCode;
      } else {
        this.phone.selectCountry(pickerData[indexOfDialCode].iso2);
        return pickerData[indexOfDialCode].dialCode;
      }
    } else {
      if (Platform.OS === 'web') {
        const indexOfAus = pickerData.map(e => e.iso2).indexOf("au");
        return pickerData[indexOfAus].dialCode;
      } else {
        const indexOfAus = pickerData.map(e => e.iso2).indexOf("au");
        return pickerData[indexOfAus].dialCode;
      }
    }
  };

  getCountryDropDown = () => {
    return this.phone.getPickerData();
  };

  getCountryPickerElement = (thumbnailLink, dialCode) => {
    let thumbnailElement = <View style={styles.thumbnailElementView} />;
    if (thumbnailLink) {
      thumbnailElement = (
        <View style={styles.thumbnailElement}>
          <Image
            resizeMode={"cover"}
            style={styles.thumbnailElementImageWeb}
            source={{ uri: thumbnailLink }}
          />
          <Text style={styles.thumbnailText}>{dialCode}</Text>
        </View>
      );
    }
    return thumbnailElement;
  };

  showPicker = () => {
    this.phone.picker.show();
  }

  getDropdownRowWidth = () => {
    const isMobile = window.innerWidth <= 550;
    if (Platform.OS == "web") {
      if (isMobile) {
        return "100%";
      }
      return "25%";
    }
    return "90%";
  };

  setNewCC = (ref) => {
    this.props.setPhone(ref);
    this.phone = ref;
  }

  countrySelected = (iso2) => {
    const { onDialCodeSet } = this.props;
    const countryData = PhoneNumber.getCountryDataByCode(iso2);
    if (countryData && onDialCodeSet) {
      onDialCodeSet(`+${countryData.dialCode}`);
    }
  };

  render() {
    const { defaultCountry, pickerDataWithImage, } = this.state;
    const { useTransparentTheme = false,
       customControlStyle = {},
       customOptionStyle = {},
       mainContainerStyle = {},
       defaultCountry: defaultCountryProp,
      } = this.props;
    return (
      <View style={{ width: '30%'}}>
        {Platform.OS == "web" ? (
          <View style={[styles.phoneInputContainerWeb, mainContainerStyle]}>
              <PhoneInput
                initialCountry="au"
                ref={ref => {
                  this.phone = ref;
                }}
                style={styles.phoneInputWeb}
              />
              {pickerDataWithImage && defaultCountry &&
                <Field
                  forwardRef
                  useTransparentTheme={useTransparentTheme}
                  showThumbnailInLabel={true}
                  name="countryCode"
                  showLabel={false}
                  valueKey="dialCode"
                  displayKey="label"
                  isRequired={false}
                  defaultValue={defaultCountry}
                  placeholder="thumbnail"
                  options={pickerDataWithImage}
                  component={Dropdown}
                  isSearchable={true}
                  rowWidth={this.getDropdownRowWidth()}
                  height="100%"
                  ref={ref => this.props.setCountryCode(ref)}
                  menuListStyle={{width: defaultScale(200)}}
                  controlStyle={customControlStyle}
                  optionContainer={customControlStyle}
                  controlTextStyle={customOptionStyle}
                  optionTextStyle={customOptionStyle}
                />}
          </View>
        ) : (
            <View style={styles.phoneNumberContainer}>
              <TouchableOpacity onPress={() => { this.showPicker() }}>
                <View style={[styles.phoneInputContainer]} ref={node => { this.node = node; }}>
                  <PhoneInput
                    ref={ref => this.setNewCC(ref)}
                    initialCountry={defaultCountryProp ?? 'au'}
                    selectCountry={defaultCountry}
                    onSelectCountry={this.countrySelected}
                    pickerButtonColor={Theme.PRIMARY}
                    buttonTextStyle={[styles.pickerButton, { backgroundColor: 'red' }]}
                    textProps={{ editable: false, disabled: true }}
                    pickerItemStyle={styles.pickerItemStyle}
                    style={[styles.phoneInput, customControlStyle]}
                    textStyle={[styles.phoneInputText, customOptionStyle]}
                  />
                </View>
              </TouchableOpacity>
            </View>
          )}
      </View>
    )
  }
}

const styles = StyleSheet.create({
	phoneInputWeb: {
		display: "none"
	},
	phoneNumberContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
	},
	phoneInputContainerWeb: {
    width: '95%',
    marginRight: defaultScale(5),
    marginTop: defaultScale(6),
	},
  mobileNumberContainerWeb: {
    flex: 1,
	},
	pickerButton: {
    fontSize: 16
	},
	pickerItemStyle: {
    fontSize: 24,
	},
	phoneInput: {
    backgroundColor: Theme.GREY_LIGHT,
    borderRadius: 3,
    paddingHorizontal: defaultScale(10),
    paddingVertical: defaultScale(10),
    marginTop: defaultScale(5),
    marginBottom: defaultScale(5),
    width: "80%"
	},
	phoneInputText: {
    color: "black",
	},
	mobileNumberContainer: {
    flex: 1
	},
	thumbnailElement: {
    flexDirection: "row",
    alignItems: "flex-start"
  },
  thumbnailElementView: {
    backgroundColor: Theme.WHITE,
    width: defaultScale(20),
    height: defaultScale(10),
    flexDirection: "row",
    alignItems: "flex-start"
  },
  thumbnailElementImage: {
    width: defaultScale(25),
    height: defaultScale(15),
    marginTop: defaultScale(13)
  },
  thumbnailElementImageWeb: {
    width: defaultScale(20),
    height: defaultScale(10),
    marginTop: defaultScale(5)
  },
  thumbnailText: {
    marginLeft: defaultScale(5),
    marginTop: defaultScale(2)
  },
  phoneInputContainer: {
    width: defaultScale(120),
    marginRight: defaultScale(5)
  },
});


CountryCodePicker = reduxForm({ form: 'CountryCode' })(CountryCodePicker);
export default translate(['payments'], { wait: true })(CountryCodePicker);
